import React from "react";
import useTheme from "../../ColorConfig/usetheme";

const LiveIndicator = () => {
  const colors = useTheme();
  
  return (
    <div className="live-indicator">
      <div className="live-pulse"></div>
      <span className="live-text">LIVE</span>
    </div>
  );
};

export default LiveIndicator;